import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProductoCartaMovil = ({ title, description, linkText, linkNavigation, svg }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    if (linkNavigation) {
      navigate(linkNavigation);
    }
  };

  return (
    <div className="relative h-[25rem] w-full sm:w-[18rem] group mx-auto">
      <div className="absolute h-full w-full rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 border border-zinc-700 shadow-xl overflow-hidden transition-all duration-500 group-hover:border-blue-500 group-hover:shadow-2xl group-hover:shadow-blue-500/20 flex flex-col">
        {/* Top accent line */}
        <div className="h-1 bg-gradient-to-r from-zinc-900 via-zinc-500 to-zinc-500"></div>

        {/* Icon section with circular background */}
        <div className="flex-1 flex items-center justify-center relative p-6">
          <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500">
            <div className="absolute inset-6 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 blur-2xl"></div>
          </div>
          <div className="relative z-10 transform transition-transform duration-500 group-hover:scale-110">
            <div className="w-32 h-32 text-white rounded-full bg-gradient-to-br from-zinc-700 to-zinc-800 flex items-center justify-center border border-zinc-600 group-hover:border-blue-500 transition-colors duration-500">
              {svg}
            </div>
          </div>
        </div>

        {/* Content section */}
        <div className="px-6 pb-6 flex flex-col gap-4">
          <div className="text-center">
            <h3 className="text-xl font-messina tracking-wide text-white mb-2 group-hover:text-blue-300 transition-colors duration-300">
              {title}
            </h3>
            <h4 className="text-sm text-zinc-300 leading-relaxed">{description}</h4>
          </div>

          {/* Link with modern underline */}
          <div className="flex justify-center pt-2">
            <a
              onClick={handleLinkClick}
              className="relative text-white hover:text-white cursor-pointer text-sm font-semibold transition-colors duration-300"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {linkText}
              <span
                className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 transition-all duration-300 ${
                  isHovered ? "w-full" : "w-0"
                }`}
              ></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductoCartaMovil;